export default {
    setCurrentStatuses(state, data) {
        state.counters = data.counters;
        state.groups = data.groups;
    }
}
